module.exports = __webpack_public_path__ + "_assets/img/pin-on-c1.adff5fbe.svg";